/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Asset, Asset$inboundSchema } from "./asset.js";

export type UploadImageResult = {
  asset: Asset;
};

/** @internal */
export const UploadImageResult$inboundSchema: z.ZodMiniType<
  UploadImageResult,
  unknown
> = z.object({
  asset: Asset$inboundSchema,
});

export function uploadImageResultFromJSON(
  jsonString: string,
): SafeParseResult<UploadImageResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UploadImageResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UploadImageResult' from JSON`,
  );
}
